import { render } from "./quantitative-data.vue?vue&type=template&id=10f59f2a"
import script from "./quantitative-data.vue?vue&type=script&lang=js"
export * from "./quantitative-data.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__